import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-carousel',
  templateUrl: './workflow-carousel.component.html'
})
export class WorkflowCarouselComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
